/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

/* eslint-disable max-len */

import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './PaymentStatus.css';
import { connect } from 'react-redux'
import GrayPanel from '../../components/GrayPanel';
import Link from '../../components/Link';
import cx from 'classnames';
import Select from 'react-select';
import { fetchStatus } from '../../lib/utils';
import _ from 'lodash';
import history from '../../core/history';
import PowrotDoListyEuslug from '../../components/PowrotDoListyEuslug';
import waiting from './waiting-wheel-300x300.gif';
const isBrowser = typeof window !== 'undefined' && window !== null;
import fetch from '../../core/fetch';
import { portalMode } from '../../config';
import { PODLASKIE_MODE } from '../../constants'
import { isMobileView, isTabletView } from '../../components/utils/utils'


const buttonPayStyle = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
  marginLeft: '10px'
}

class PaymentStatus extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    jobID: React.PropTypes.string,
    claim: React.PropTypes.object,

  };

  state = {
    toPay: 0.00,
    docs: [],
    paymentStatus: this.props.claim.paymentStatus,
    isMounted: false,
    bankAccount: this.props.bankAccounts[0],
  }

  componentDidMount = () => {
    fetch(`${process.env.API_URL}/eservice/${this.props.claim.teryt}/${this.props.claim.shortName}`)
      .then(r => r.json())
      .then(resp => {
        this.setState({
          eserviceDistrict: resp,
        });
      });
    this.setState({ isMounted: true });
  }

  getPaymentStatus = paymentMethod => {
    // fetchStatus
    if (!this.state.disablePayment && paymentMethod.fk_method == '3' && this.state.paymentStatus === 'STARTED') {
      setTimeout(() => {
        fetchStatus(this.props.claim.jobId)
          .then(r => {
            if (r.status === 'STARTED') {
              this.getPaymentStatus(paymentMethod);
            } else {
              // window.href = `${window.location.host}/paymentStatus/${this.props.claim.jobId}`
              this.setState({ paymentStatus: r.status });
            }
          })
      }, 1000);
    }
  }

  renderDownloadButton = (isMobile, sum_cost, claim) => {
    if (sum_cost <= 0. && (claim.shortName != "invest_contact" && claim.shortName != "invest_contact_form")) {
      return (
        <a
          className={isMobile ? "btn btn-warning pull-left mobile-button" : "btn btn-warning pull-left"}
          target="_blank"
          href={`${process.env.API_URL}/eservices/getJobApplication/${this.props.jobID}`}
          style={buttonPayStyle}>
            Pobierz wniosek
        </a>
      )
    }

    return null;
  }

  render() {
    const paymentMethod = _.find(this.props.paymentMethods, v => v.id == this.props.claim.paymentMethod);

    if (!this.state.disablePayment && paymentMethod) {
      this.getPaymentStatus(paymentMethod);
    }
    const failures = this.props.claim.failures;
    const hasJobFailure = failures.reduce((prev, current) => current.failureType === "JobFailure" ? current : null, null);
    // layout classes
    const leftCol = 'col-sm-2';
    const labelCol = 'col-sm-2';
    const inputCol = 'col-sm-6';
    const rightCol = 'col-sm-2';

    // really simple styles
    const labelStyle = { marginTop: '.5rem' };
    const rowStyle = { marginTop: '15px' };
    const claim = this.props.claim;
    const service = this.props.eservices[claim.shortName];

    const sum_cost = claim.documents.reduce((prev, next) => prev += next.cost, 0.00).toFixed(2);

    // if (claim.shortName == "invest_contact") {
    //   return (<h1>OK</h1>);
    // }
    let confirmText1 = 'Twój wniosek został przekazany do Urzędu. Upewnij się czy dokonałeś opłaty za dokumenty. O dalszych krokach realizacji e-usługi będziesz informowany przez osobę realizującą Twoją sprawę.';
    // let confirmText2 = 'W sekcji podgląd wzorów dokumentów umieszczamy wzory przygotowanych dokumentów. Oryginały dokumentów zostaną przekazane przez Urząd zgodnie z wybranym sposobem doręczenia';

    // if (this.props.claim && this.props.claim.teryt === '604011' && this.props.claim.shortName === 'WypisIWyrysZMpzp') {
    //   confirmText1 = '';
    //   confirmText2 = '';
    // }

    let isMobile = false;
    let isTablet = false;
    if (this.state.isMounted) {
      isMobile = isMobileView(window);
      isTablet = isTabletView(window);
    }

    return (
      <div className={s.root}>
        <div className={s.container}>
          {this.state.isMounted ?
            <GrayPanel title="Podsumowanie">
              <div className="row" style={rowStyle}>
                <div className={leftCol} />
                <div className={labelCol}>
                  <label style={labelStyle}>Nazwa usługi:</label>
                </div>
                <div className={inputCol}>
                  <p style={labelStyle}>{service.title}</p>
                </div>
                <div className={rightCol} />
              </div>

              <div className="row" style={rowStyle}>
                <div className={leftCol} />
                {claim.parcels.length > 0 ? (
                  <div>
                    <div className={labelCol}>
                      <label style={labelStyle}>Lista działek:</label>
                    </div>
                    <div className={inputCol}>
                      {claim.parcels.map((parcel, i) => <span key={i}>{`${parcel.parcel}; `}</span>)}
                    </div>
                  </div>
                ) : null}
                <div className={rightCol} />
              </div>
              {hasJobFailure ?
                <div>
                  <h5>{hasJobFailure.reasonDisplay}</h5>
                </div>
                :
                <div>
                  {
                    claim.documents.length ?
                      [
                        (<hr />),
                        (
                          <h3>{(sum_cost > 0.) && paymentMethod && (this.state.paymentStatus !== "SUCCESS") ? "Opłata za dokumenty" : "Podgląd wzorów dokumentów"}</h3>
                        ),
                        (<table className="table table-hover">
                          <thead>
                            <tr>
                              <th>Nazwa pliku</th>
                              <th style={{ textAlign: 'center' }}>
                                {sum_cost > 0. ?
                                  `Wysokość opłaty` : null
                                }
                              </th>
                              {paymentMethod && ((paymentMethod.fk_method == '3' && this.state.paymentStatus === 'SUCCESS')) ?
                                <th style={{ textAlign: 'center', marginRight: '5px' }}>Akcje</th>
                                : null
                              }
                            </tr>
                          </thead>
                          <tbody>
                            {claim.documents.map((doc, i) =>
                              <tr key={i}>
                                <td>{doc.fileName}</td>
                                <td style={{ textAlign: 'center' }}>
                                  {sum_cost > 0. && `${doc.cost.toFixed(2)} PLN`}
                                </td>
                                {/* {!paymentMethod || (paymentMethod && (paymentMethod.fk_method == '3' && this.state.paymentStatus === 'SUCCESS')) ?
                                  <td style={{ textAlign: 'right' }}>
                                    {claim.documents.length < 1 ?
                                      <a className="btn btn-warning pull-right" target="_blank" href={`${process.env.API_URL}/eservices/getJobApplication/${this.props.jobID}`} style={buttonPayStyle}>Pobierz</a> :
                                      <a className="btn btn-warning pull-right" target="_blank" href={`${process.env.API_URL}/eservices/getEscDocument/${doc.id}`} style={buttonPayStyle}>Pobierz</a>
                                    }
                                  </td>
                                  : null} */}
                              </tr>,
                            )}
                          </tbody>
                        </table>),
                        (<hr />)
                      ] : null
                  }

                  {claim.shortName == "invest_contact" || claim.shortName == "invest_contact_form" ? (
                    <table className="table table-hover">
                      <thead>
                        <tr>
                          <th>Nazwa pliku</th>
                          <th style={{ textAlign: 'right' }}>Akcje</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>List intencyjny inwestora</td>
                          <td style={{ textAlign: 'right' }}>
                            <a className="btn btn-warning pull-right" target="_blank" href={`${process.env.API_URL}/invest/getInvestDoc/${this.props.jobID}`} style={buttonPayStyle}>Pobierz</a>
                          </td>
                        </tr>
                      </tbody>
                    </table>) : null
                  }

                  {sum_cost > 0. &&
                    (paymentMethod && ((this.state.disablePayment || (this.state.paymentStatus === "SUCCESS" && paymentMethod.fk_method == '3'))) ?
                      <div className="row" style={{ marginLeft: '10px', marginRight: '10px' }}>
                        <span className="pull-left">Status</span>
                        <span className="pull-right"><b>Opłacono</b></span>
                      </div>
                      :
                      <div className="row" style={{ marginLeft: '10px', marginRight: '10px' }}>
                        <span className="pull-left">Łącznie</span>
                        <span className="pull-right"><b>{sum_cost} PLN</b></span>
                      </div>)
                  }
                  {sum_cost > 0. && paymentMethod && paymentMethod.fk_method != '3' ?
                    <div className="row">
                      <br />
                      <span className="pull-left"><b>Numer rachunku: {this.state.bankAccount && this.state.bankAccount.name ? this.state.bankAccount.name : '-'}</b></span>
                      <span className="pull-right">{this.state.bankAccount.number}</span>
                    </div>
                    : null
                  }

                  <br />

                  <div className="row" style={rowStyle}>
                    <div className="row" style={{marginLeft: "15px", marginRight: "15px"}}>
                      {sum_cost > 0. &&
                        <a className="btn btn-warning pull-left mobile-button" target="_blank" href={`${process.env.API_URL}/eservices/getJobApplication/${this.props.jobID}`} style={buttonPayStyle}>Pobierz wniosek</a>
                      }
                      {sum_cost > 0. && (paymentMethod && (paymentMethod.fk_method == '3' && this.state.paymentStatus === 'SUCCESS')) ?
                        <a className="btn btn-primary pull-right mobile-button" href={`${process.env.API_URL}/eservices/getJobDocs/${this.props.jobID}`} style={buttonPayStyle}>Pobierz wszystko</a>
                        : null}

                      {paymentMethod && (paymentMethod.fk_method == '3' && this.state.paymentStatus === 'waiting') ?
                        <a className="btn btn-primary pull-right mobile-button" href={`/api/v1.0/eservices/jobPayment/${this.props.jobID}`} style={buttonPayStyle}>Zapłać</a>
                        : null}
                      {paymentMethod && (paymentMethod.fk_method == '3' && (this.state.paymentStatus === 'waiting' || this.state.paymentStatus === 'FAILURE')) ?
                        <a className={portalMode == PODLASKIE_MODE ? "btn btn-warning pull-right mobile-button" : "btn btn-primary pull-right mobile-button"} href={`/eservices/eserviceSummary/${this.props.jobID}`} style={buttonPayStyle}>Wróć do wyboru formy płatności</a>
                        : null}
                      {paymentMethod && (paymentMethod.fk_method == '3' && this.state.paymentStatus === 'STARTED') ?
                        <b><span className="pull-right">Czekamy na odpowiedź z banku <img style={{ width: '48px', height: '48px' }} role="presentation" src={waiting} /></span></b>
                        : null}
                      {paymentMethod && (paymentMethod.fk_method == '3' && this.state.paymentStatus === 'FAILURE') ?
                        <span className="pull-right" style={{ color: 'red' }}>Nie udało się dokonać przelewu, prosimy zgłosić się do ekipy GIAP w celu weryfikacji zaistniałej sytuacji lub wrócić do wyboru formy płatności.</span>

                        : null}

                    </div>
                    <div className="row">
                      <h5 style={{ textAlign: 'justify', marginLeft: '25px', marginRight: '25px' }}>
                        <br />
                        {((sum_cost > 0.00 && paymentMethod && ((paymentMethod.fk_method != '3') || (paymentMethod.fk_method == '3' && this.state.paymentStatus === 'SUCCESS'))) && (claim.shortName !== 'invest_contact_form' || claim.shortName !== 'invest_contact')) ?
                          confirmText1 :
                          null
                        }
                        {(paymentMethod && paymentMethod.fk_method == '3' && this.state.paymentStatus !== 'SUCCESS') ?
                          'Twój wniosek zostanie przekazany do urzędu po dokonaniu płatności. ' :
                          null
                        }
                        {claim.shortName === 'invest_contact' || claim.shortName === 'invest_contact_form' ?
                          <p>List intencyjny trafił do urzędu. O dalszych krokach realizacji e-usługi będziesz informowany przez osobę realizującą Twoją sprawę.</p> : null
                        }
                        <br />
                        <br /><br />
                    </h5>
                    {isMobile || isTablet ? 
                      <div style={{marginLeft: "15px", marginRight: "15px"}}>
                        <div className="col-sm-12">
                        {this.renderDownloadButton(true, sum_cost, claim)}
                        <PowrotDoListyEuslug position="right" prefix={this.props.claim.prefix} className="mobile-button"/>
                        </div>
                      </div> :
                      <div className="row">
                        {this.renderDownloadButton(false, sum_cost, claim)}
                        <PowrotDoListyEuslug position="right" prefix={this.props.claim.prefix} className="powrot-button"/>
                      </div>
                    }
                    </div>
                  </div>
                </div>
              }
              {/* {this.props.user.username === "habibi07" ? <div>
              <a className="btn btn-primary pull-right" href={`${process.env.API_URL}/eservices/getJobDocs/${this.props.jobID}`} style={buttonPayStyle}>Pobierz wszystko</a>
              <a className="btn btn-primary pull-right" href={`${process.env.API_URL}/service/requeue/${this.props.jobID}`} style={buttonPayStyle}>Uruchom ponownie</a>
              {claim.documents.map((doc, i) => <a className="btn btn-warning pull-left" key={i} target="_blank" href={`${process.env.API_URL}/eservices/getEscDocument/${doc.id}`} style={buttonPayStyle}>Pobierz</a>)}
            </div> : null } */}

            </GrayPanel>
            : <GrayPanel title="Podsumowanie" bodyStyle={{ textAlign: 'center !important', marginTop: '100px', marginBottom: '100px' }}><img role="presentation" src={waiting} /></GrayPanel>}
        </div>
      </div>
    );
  }
}

PaymentStatus.contextTypes = {
  fontSizeScale: React.PropTypes.number,
};


const mapState = state => ({
  eservices: state.district.eservices,
  districts: state.district.districts
});

export default withStyles(s)(connect(mapState)(PaymentStatus));



// WEBPACK FOOTER //
// src/routes/paymentStatus/PaymentStatus.js